$(document).ready(function () {

    $(".mobile-navi-bar").click(function () {
        $("#mobile-navi").toggleClass("active");
        $(".mobile-navi").animate({width: "toggle"});
    });

    $("li.menu-item.has-sub-menu").click(function () {
        $(this).toggleClass("active");
        $(this).children(".mobile-sub-menu").animate({height: "toggle"});
    });

    var navigationCollapse = null;

    function getTarget() {
        if (navigationCollapse === null) {
            navigationCollapse = document.getElementById('mobileNav');
        }
        return navigationCollapse;
    }

    /* Hide Navigation after tabbing out */
    document.addEventListener('keyup', function (event) {
        if ($("#mobile-navi").hasClass("active")) {
            if (event.keyCode == 9) {
                if (!getTarget().contains(document.activeElement)) {
                    $("#mobile-navi").toggleClass("active");
                    $(".mobile-navi").animate({width: "toggle"});
                }
            }
        }
    });

    /* Move textblock of user data form between label and checkbox */
    var newsletterTextBlock = $('.newsletter-disclaimer-block');
    newsletterTextBlock.parent().remove();
    $(newsletterTextBlock).insertBefore($('#applyForm-newsletter').parent());
    var personSearchTextBlock = $('.person-search-agreement-disclaimer-block');
    personSearchTextBlock.parent().remove();
    $(personSearchTextBlock).insertBefore($('#applyForm-person_search_agreement').parent());
    var roleDescriptionBlock = $('.role-description-block');
    roleDescriptionBlock.parent().remove();
    $(roleDescriptionBlock).insertBefore($('#applyForm-role').parent());

    /* Show person search disclaimer popup */
    if (typeof showPersonSearchDisclaimer !== 'undefined' && showPersonSearchDisclaimer === true) {
        const fancybox = new Fancybox([
            {
                src: showPersonSearchDisclaimerUrl,
                type: "iframe",
            },
        ]);
        fancybox.on('load', (fancybox, slide) => {
            $('#fancybox__iframe_1_0').contents().find('body #gdcc-wrapper').remove();
        });
    }

    /* Show Zoom disclaimer popup */
    if (typeof showZoomDisclaimer !== 'undefined' && showZoomDisclaimer === true) {
        const fancybox = new Fancybox([
            {
                src: showZoomDisclaimerUrl,
                type: "iframe",
            },
        ]);
        fancybox.on('load', (fancybox, slide) => {
            $('#fancybox__iframe_1_0').contents().find('body #gdcc-wrapper').remove();
        });
    }

    /* Show data processing disclaimer popup */
    if (typeof showDataProcessingDisclaimer !== 'undefined' && showDataProcessingDisclaimer === true) {
        const fancybox = new Fancybox([
            {
                src: showDataProcessingDisclaimerUrl,
                type: "iframe",
                click: function () {
                    // Nothing. Prevent user from closing fancybox.
                },
            },
        ]);
        fancybox.on('load', (fancybox, slide) => {
            $('#fancybox__iframe_1_0').contents().find('body #gdcc-wrapper').remove();
            $('div.fancybox__container button.carousel__button.is-close').hide();
        });
    }

    /* Delete photo of fe_user */
    $('.delete-photo').on('click', function(e){
        var decision = confirm('Do you really want to delete this photo?' + "\n" + 'Your photo can not be restored.');
        if (decision === false) {
            e.preventDefault();
            return false;
        } else {
            $('#applyForm-deletePhoto').val('true');
        }
    });

    /* Twitter Box */
    if (typeof deleteTwitterConsentCookie !== 'undefined') {
        deleteTwitterConsent();
    }
    var twitterBox = $('.twitter-timeline-box');
    if (twitterBox.length) {
        $('.set-disclaimer').on('click', function(e){
            e.preventDefault();
            createCookie('twitter_consent_cookie', 'show');
            setCookieConsent('twitter');
            var twitterBoxes = $('section[id^="twitter-box-"]');
            window.location.href += '#' + twitterBoxes.eq(0).attr("id");
            location.reload();
        });
    }

/*    if (typeof deleteVimeoConsentCookie !== 'undefined') {
        deleteVimeoConsent();
    }
    var vimeoBox = $('.vimeo-box');
    if (vimeoBox.length) {
        $('.set-vimeo-disclaimer').on('click', function(e){
            e.preventDefault();
            createCookie('vimeo_consent_cookie', 'show');
            setCookieConsent('vimeo');
            var vimeoBoxes = $('.vimeo-box[id^="vimeo-box-"]');
            window.location.href += '#' + vimeoBoxes.eq(0).attr("id");
            location.reload();
        });
    }*/

    function initTwoClick() {
        function setCookie(key, value) {
            var expires = new Date();
            expires.setTime(expires.getTime() + 2592000); //1 month
            document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
        }

        function getCookie(key) {
            var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
            return keyValue ? keyValue[2] : null;
        }

        var vimeoConsentYES = $('.set-vimeo-disclaimer');
        var twoClickInfo = $('.vimeo-box .vimeo-disclaimer');
        var twoClickContent = $('.vimeo-box .two-click-content');
        function initTwoClickContent() {
            $('.vimeo-box').each(function(){
                twoClickContent.show();
                var noscript = $(this).find($('noscript'));
                var noscriptContents = noscript.html();
                $(this).find('.two-click-content').html(noscriptContents);

            });
        }

        vimeoConsentYES.on('click', function(e) {
            e.preventDefault();
            setCookie('twoClickConsent', 'true');
            twoClickInfo.hide();
            /* init Content */
            initTwoClickContent();
        });

        var videoConsent = getCookie('twoClickConsent');

        if (videoConsent != 'true') {
            twoClickInfo.css('display', 'flex');
        } else {
            twoClickInfo.hide();
            twoClickContent.show();
            /* init Map */
            initTwoClickContent();
        }
    }

    initTwoClick();

});

function createCookie (name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + value + expires + "; path=/";
}

function getCookieValue (value) {
    const b = document.cookie.match('(^|;)\\s*' + value + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}

function setCookieConsent (cookieId) {
    var cookieValue = getCookieValue('gdcc-cookie-consent-settings');
    if (cookieValue.length > 0) {
        var cookieConsentValues = JSON.parse(getCookieValue('gdcc-cookie-consent-settings'));
        var cookieObject = [];
        jQuery.each(cookieConsentValues, function (index, value) {
            if (value.id === cookieId) {
                cookieObject[index] = {"id":"twitter","checked":1};
                cookieObject[index] = {"id":"vimeo","checked":1};
            } else {
                cookieObject[index] = value;
            }
        });
        createCookie('gdcc-cookie-consent-settings', JSON.stringify(cookieObject));
    } else {
        createCookie('gdcc-cookie-consent-settings', '[{"id":"cookie-consent","checked":1},{"id":"twitter","checked":1},{"id":"vimeo","checked":1}]');
    }
}

function deleteTwitterConsent () {
    document.cookie = 'twitter_consent_cookie=; Max-Age=-99999999;';
}

function deleteVimeoConsent () {
    document.cookie = 'vimeo_consent_cookie=; Max-Age=-99999999;';
}
